import React from "react";
import ReactDOM from "react-dom";
import App from "components/App.jsx";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

import "assets/css/material-dashboard-react.css?v=1.5.0";

const hist = createBrowserHistory();

ReactDOM.render(
  // TODO Make App the root component. Has dependancy with Sidebar and Dashboard (history.location) components
  <Router history={hist}>
    <Switch>
      <Route path="/" component={(props) => <App {...props} />} />
    </Switch>
  </Router>,
  document.getElementById("root")
);
